import { Dialog, DialogActions, DialogProps, DialogTitle, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import * as S from './dialog.styles';
import {DialogTitleContainer} from "./dialog.styles";
import {BaseButton} from "../button";

// Transition component
const Transition = React.forwardRef(
    (props: TransitionProps & { children: React.ReactElement<any, any> }, ref: React.Ref<unknown>) => {
        return <Slide direction="up" ref={ref} {...props} />;
    },
);

export interface IBaseDialogProps extends Omit<DialogProps, 'ref'> {
    renderTitle?: string;
    renderActions?: React.ReactElement | React.ReactElement[];
    showCloseButton?: boolean;
    disableBackdropClick?: boolean;
    fullScreen?: boolean;
    expandable?: boolean;
}

export interface ICommonDialogProps {
    props: Omit<IBaseDialogProps, 'open'>;
    commonDialogContext?: ICommonDialogContext;
    Component: React.ReactNode;
}

export interface IMixedDialogContext {
    showDialog?: (props: ICommonDialogProps) => void;
    hideDialog?: () => void;
    openModal?: ((props: ICommonDialogProps) => void) | undefined;
    closeModal?: (() => void) | undefined;
}

export interface ICommonDialogContext {
    show: (props: ICommonDialogProps) => void;
    hide: () => void;
}

export function useCommonDialogContext(mixedDialogContext: IMixedDialogContext): ICommonDialogContext {
    return new CommonDialogContext(mixedDialogContext);
}

export class CommonDialogContext implements ICommonDialogContext {

    private mixedDialogContext: IMixedDialogContext;
    constructor(mixedDialogContext: IMixedDialogContext) {
        this.mixedDialogContext = mixedDialogContext;
    }

    public show(props: ICommonDialogProps): void {
        if(this.mixedDialogContext.showDialog) {
            this.mixedDialogContext.showDialog(props);
        } else if(this.mixedDialogContext.openModal) {
            this.mixedDialogContext.openModal(props);
        } else {
            console.error("mixedDialogContext is missing");
        }
    }

    public hide(): void {
        if(this.mixedDialogContext.hideDialog) {
            this.mixedDialogContext.hideDialog();
        } else if(this.mixedDialogContext.closeModal) {
            this.mixedDialogContext.closeModal();
        } else {
            console.error("mixedDialogContext is missing");
        }
    }
}

export class BaseDialog extends React.PureComponent<IBaseDialogProps> {
    private onClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (this.props.disableBackdropClick && reason === 'backdropClick') {
            return false;
        }

        if (this.props.disableBackdropClick && reason === 'escapeKeyDown') {
            return false;
        }

        if (typeof this.props.onClose === 'function') {
            this.props.onClose(event, reason);
        }
    };

    private handleButtonClickClose = (): void => {
        if (typeof this.props.onClose === 'function') {
            this.props.onClose({}, 'backdropClick');
        }
    };

    public render(): React.ReactElement {
        const { renderTitle, children, renderActions, showCloseButton, disableBackdropClick, expandable, ...props } = this.props;
        console.log("showCloseButton=" + showCloseButton)
        return (
            <Dialog TransitionComponent={Transition} fullScreen={!!props.fullScreen} maxWidth={false} {...props} onClose={this.onClose}>
                {renderTitle && (
                    <DialogTitle style={{display: 'flex', justifyContent: 'space-between'}}>
                        {showCloseButton ? <S.DialogTitleContainer>
                            <S.DialogTitle>{renderTitle}</S.DialogTitle>
                            <S.DialogCloseButtonContainer><BaseButton onClick={this.handleButtonClickClose}>Close</BaseButton></S.DialogCloseButtonContainer>
                        </S.DialogTitleContainer> : <S.DialogTitle>{renderTitle}</S.DialogTitle>}
                    </DialogTitle>
                )}
                {expandable ? <S.OverflowedStyledDialogContent>{children}</S.OverflowedStyledDialogContent> : <S.StyledDialogContent>{children}</S.StyledDialogContent>}
                {renderActions && (
                    <DialogActions>
                        <S.ActionsContainer>{renderActions}</S.ActionsContainer>
                    </DialogActions>
                )}
            </Dialog>
        );
    }
}
